module.exports = __webpack_public_path__ + "static/campagne_map-9dd33c30a25d74421f762c63a220c0c8.svg";